import React, { useState } from "react";
import Header from "../../components/Header";
import Watermark from '../../assets/Watermark.png';
import AddAppUser from "../../components/AddUser/AddAppUser";
import AddFaculty from "../../components/AddUser/AddFaculty";
import AddAdminUser from "../../components/AddUser/AddAdminUser";

export default function AddUsers() {
    const [activeTab, setActiveTab] = useState("appUser");

    return (
        <div
            className="p-4 space-y-4"
            style={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                backgroundImage: `url(${Watermark})`,
                backgroundSize: '45%',
                backgroundPosition: 'center 20px',
                backgroundRepeat: 'no-repeat'
            }}
        >
            <Header />

            {/* Tabs */}
            <div className="flex mb-6 overflow-hidden rounded-t-lg shadow-md bg-white">
                <button
                    className={`flex-1 px-6 py-3 text-sm font-semibold transition-all duration-200 focus:outline-none ${activeTab === "appUser"
                            ? "bg-[#900028] text-white"
                            : "bg-[#F2C7C9] bg-opacity-60 text-black-900"
                        }`}
                    onClick={() => setActiveTab("appUser")}
                >
                    Add App User
                </button>

                {/* Vertical Separator */}
                <div className="w-px bg-[#900028]" />

                <button
                    className={`flex-1 px-6 py-3 text-sm font-semibold transition-all duration-200 focus:outline-none ${activeTab === "faculty"
                            ? "bg-[#900028] text-white"
                            : "bg-[#F2C7C9] bg-opacity-60 text-black-900"
                        }`}
                    onClick={() => setActiveTab("faculty")}
                >
                    Add Faculty
                </button>

                {/* Vertical Separator */}
                <div className="w-px bg-[#900028]" />

                <button
                    className={`flex-1 px-6 py-3 text-sm font-semibold transition-all duration-200 focus:outline-none ${activeTab === "admin"
                            ? "bg-[#900028] text-white"
                            : "bg-[#F2C7C9] bg-opacity-60 text-black-900"
                        }`}
                    onClick={() => setActiveTab("admin")}
                >
                    Add Admin User
                </button>
            </div>


            {/* Tab Content */}
            <div className="flex-grow">
        {activeTab === "appUser" && <AddAppUser />}
        {activeTab === "faculty" && <AddFaculty />}
        {activeTab === "admin" && <AddAdminUser />}
      </div>
        </div>
    );
}
